import { Fragment } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

function TermsOfService(props) {
    var { pathname } = useLocation();

    return (
        <Fragment>
            <div
                id="kt_body"
                data-bs-spy="scroll"
                data-bs-target="#kt_landing_menu"
                className="bg-body position-relative"
            >
                <div className="d-flex flex-column flex-root">
                    <div className="mb-0" id="home">
                        <div className="bgi-no-repeat bgi-size-contain bgi-position-x-center bgi-position-y-bottom landing-dark-bg">
                            <div
                                className="landing-header"
                                data-kt-sticky="true"
                                data-kt-sticky-name="landing-header"
                                data-kt-sticky-offset="{default: '200px', lg: '300px'}"
                            >
                                <div className="container">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center flex-equal">
                                            <button
                                                className="btn btn-icon btn-active-color-primary me-3 d-flex d-lg-none"
                                                id="kt_landing_menu_toggle"
                                            >
                                                <i className="ki-outline ki-abstract-14 fs-2hx"></i>
                                            </button>
                                            <Link to="/">
                                                <img
                                                    alt="Logo"
                                                    src={require("components/assets/media/custom/logo.png")}
                                                    className="logo-default h-60px h-lg-60px"
                                                />
                                                <img
                                                    alt="Logo"
                                                    src={require("components/assets/media/custom/logo.png")}
                                                    className="logo-sticky h-20px h-lg-25px"
                                                />
                                            </Link>
                                        </div>
                                        <div className="d-lg-block" id="kt_header_nav_wrapper">
                                            <div
                                                className="d-lg-block p-5 p-lg-0"
                                                data-kt-drawer="true"
                                                data-kt-drawer-name="landing-menu"
                                                data-kt-drawer-activate="{default: true, lg: false}"
                                                data-kt-drawer-overlay="true"
                                                data-kt-drawer-width="200px"
                                                data-kt-drawer-direction="start"
                                                data-kt-drawer-toggle="#kt_landing_menu_toggle"
                                                data-kt-swapper="true"
                                                data-kt-swapper-mode="prepend"
                                                data-kt-swapper-parent="{default: '#kt_body', lg: '#kt_header_nav_wrapper'}"
                                            >
                                                <div
                                                    className="menu menu-column flex-nowrap menu-rounded menu-lg-row menu-title-gray-600 menu-state-title-primary nav nav-flush fs-5 fw-semibold"
                                                    id="kt_landing_menu"
                                                >
                                                    <div className="menu-item">
                                                        <Link
                                                            className="menu-link nav-link active py-3 px-4 px-xxl-6"
                                                            to="#"
                                                            data-kt-scroll-toggle="true"
                                                            data-kt-drawer-dismiss="true"
                                                        >
                                                            Home
                                                        </Link>
                                                    </div>
                                                    <div className="menu-item">
                                                        <Link
                                                            className="menu-link nav-link py-3 px-4 px-xxl-6"
                                                            to="https://cotik.gitbook.io/docs"
                                                            data-kt-scroll-toggle="true"
                                                            data-kt-drawer-dismiss="true"
                                                        >
                                                            How it Works
                                                        </Link>
                                                    </div>
                                                    <div className="menu-item">
                                                        <Link
                                                            className="menu-link nav-link py-3 px-4 px-xxl-6"
                                                            to="/privacy-policy"
                                                            data-kt-scroll-toggle="true"
                                                            data-kt-drawer-dismiss="true"
                                                        >
                                                            Privacy Policy
                                                        </Link>
                                                    </div>
                                                    <div className="menu-item">
                                                        <Link
                                                            className="menu-link nav-link py-3 px-4 px-xxl-6"
                                                            to="/terms-of-service"
                                                            data-kt-scroll-toggle="true"
                                                            data-kt-drawer-dismiss="true"
                                                        >
                                                            Terms of Service
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex-equal text-end ms-1">
                                            <Link
                                                to={
                                                    pathname.indexOf("/extension") > -1
                                                        ? "/admin/extension-etsy"
                                                        : "/admin"
                                                }
                                                className="btn btn-success"
                                            >
                                                Sign In
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="landing-curve landing-dark-color mb-10 mb-lg-20">
                            <svg viewBox="15 12 1470 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M0 11C3.93573 11.3356 7.85984 11.6689 11.7725 12H1488.16C1492.1 11.6689 1496.04 11.3356 1500 11V12H1488.16C913.668 60.3476 586.282 60.6117 11.7725 12H0V11Z"
                                    fill="currentColor"
                                ></path>
                            </svg>
                        </div>
                        <div className="mt-20 position-relative z-index-2">
                            <div className="container">
                                <div className="text-center mb-17">
                                    <h2
                                        className="fs-2hx text-gray-900 mb-5"
                                        id="clients"
                                        data-kt-scroll-offset="{default: 125, lg: 150}"
                                    >
                                        Terms of Service for COTIK
                                    </h2>
                                    <p className="text-muted ">Last updated November, 2025</p>
                                </div>
                                <div className="mx-15 mb-4">
                                    <p>These Terms of Service (“Terms”) govern your access to and use of the website <strong>https://cotik.app</strong> and the application <strong>COTIK</strong> (collectively, the “Service”), operated by <strong>Generations Ecom LLC</strong> (“we”, “our”, “us”). By accessing or using the Service, you agree to be bound by these Terms.</p>

                                    <hr />

                                    <h2>1. Use of the Service</h2>
                                    <p>You must be at least 18 years old and legally capable of entering into a binding agreement to use the Service. You agree to use the Service only for lawful purposes and in compliance with these Terms, applicable laws, and the policies of third-party platforms integrated with the Service, including Etsy and TikTok Shop.</p>

                                    <hr />

                                    <h2>2. Account Registration</h2>
                                    <p>To access certain features, you may be required to create an account. You agree to provide accurate, current, and complete information. You are responsible for maintaining the confidentiality of your login credentials and for any activity under your account.</p>

                                    <hr />

                                    <h2>3. Platform Integrations (Etsy & TikTok Shop)</h2>
                                    <p>The Service may allow you to connect your store to third-party platforms such as Etsy and TikTok Shop.</p>

                                    <p>By using these integrations, you agree that:</p>
                                    <ul>
                                        <li>You authorize the Service to access certain platform data as permitted by each platform’s API.</li>
                                        <li>You will comply with Etsy's and TikTok Shop’s Terms of Use, API policies, and applicable guidelines.</li>
                                        <li>We do not endorse, control, or guarantee any third-party platform.</li>
                                        <li>You are solely responsible for the management of your marketplace accounts.</li>
                                    </ul>

                                    <hr />

                                    <h2>4. Prohibited Activities</h2>
                                    <p>You agree NOT to:</p>
                                    <ul>
                                        <li>Use the Service to violate Etsy or TikTok Shop policies.</li>
                                        <li>Interfere with the Service’s security, servers, or network.</li>
                                        <li>Reverse engineer or attempt to extract source code from the Service.</li>
                                        <li>Use the Service for automated scraping, unauthorized data collection, or spam.</li>
                                        <li>Attempt to bypass API limits or platform restrictions.</li>
                                    </ul>

                                    <hr />

                                    <h2>5. Intellectual Property</h2>
                                    <p>All content and software within the Service, except for data retrieved from your connected marketplaces, are the property of <strong>Generations Ecom LLC</strong> or its licensors and are protected by copyright and other intellectual property laws.</p>

                                    <hr />

                                    <h2>6. Subscription Fees (If Applicable)</h2>
                                    <p>If the Service includes paid features or subscription plans:</p>
                                    <ul>
                                        <li>All fees are billed in USD unless stated otherwise.</li>
                                        <li>Fees are non-refundable unless required by law.</li>
                                        <li>We may modify pricing with advance notice.</li>
                                    </ul>

                                    <hr />

                                    <h2>7. Data & Privacy</h2>
                                    <p>Your use of the Service is also governed by our <Link to="/privacy" target="_blank">Privacy Policy</Link>. By using the Service, you consent to the collection and processing of data as described in the Privacy Policy.</p>

                                    <hr />

                                    <h2>8. Disclaimers</h2>
                                    <p>The Service is provided on an “AS IS” and “AS AVAILABLE” basis. We do not warrant that the Service will be uninterrupted, error-free, secure, or compatible with all devices or platforms.</p>

                                    <p>We do not guarantee results related to sales performance, ranking, visibility, or approval on any marketplace platform.</p>

                                    <hr />

                                    <h2>9. Limitation of Liability</h2>
                                    <p>To the maximum extent permitted by U.S. law, <strong>Generations Ecom LLC</strong> shall not be liable for any indirect, incidental, special, or consequential damages, including loss of revenue, profits, data, or business opportunities, arising from your use of the Service.</p>

                                    <p>Our total liability shall not exceed the amount you paid to use the Service in the 12 months preceding the event giving rise to the claim.</p>

                                    <hr />

                                    <h2>10. Termination</h2>
                                    <p>We may suspend or terminate your access to the Service at any time, with or without cause or notice. Upon termination, your right to use the Service ceases immediately.</p>

                                    <hr />

                                    <h2>11. Governing Law</h2>
                                    <p>These Terms are governed by and interpreted in accordance with the laws of the State of Delaware or the State where your company is registered, without regard to conflict of law principles.</p>
                                    <p>Any dispute shall be resolved in a state or federal court located in the United States.</p>

                                    <hr />

                                    <h2>12. Modifications</h2>
                                    <p>We may update these Terms at any time. Continued use of the Service after changes are posted constitutes acceptance of the new Terms.</p>

                                    <hr />

                                    <h2>13. Contact Information</h2>
                                    <p>If you have questions about these Terms, contact us at:</p>

                                    <p><strong>Email:</strong> support@cotik.app<br />
                                        <strong>Company:</strong> Generations Ecom LLC<br />
                                        <strong>Address:</strong> 1942 Broadway Suite 314 C, Boulder, CO 80302</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(TermsOfService);
